import { map } from 'rxjs/operators/map';
import { IndoorMappingSerializer } from '../../models';
import ajax from '../../utils/ajax';

class IndoorMappingService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPathGroup = '/networkAsset/airfinder/indoorMappings';
  configurationPath = '/networkAsset/airfinder/area';

  /**
    Create an Indoor Mapping
    @param {Object} mapping Indoor mapping data
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (mapping, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: IndoorMappingSerializer.serialize(mapping),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => IndoorMappingSerializer.normalize(data.response)));
  };

  /**
    Get an Indoor Mapping by ID
    @param {Object} mapping Indoor mapping data
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  get = (id, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${id}/file`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => IndoorMappingSerializer.normalize(data.response)));
  };
}

export default new IndoorMappingService();



// WEBPACK FOOTER //
// ./src/services/indoormapping/index.js